import { atomWithSessionStorage } from '../useStorage/atomsWithStorages'
import { MFRM_UNIFY_CLIENTELING_PRODUCT_SEARCH_ADDED } from '../conventions'
import { productSearchSchema } from '../ProductSearchModal/schema'

export const productSearchAtom = atomWithSessionStorage(
  MFRM_UNIFY_CLIENTELING_PRODUCT_SEARCH_ADDED,
  [],
  productSearchSchema
)
